import { fromJS as defaultFromJS, isIndexed, isKeyed, Map } from 'immutable';

const skipIndexedKeys: Array<string> = ['route', 'status', 'timeVsOverview','timeVScreditUsage']
const skipInstances: Array<string> = ["textInstance"];
const fromJS = (items: Array<any>) =>
	defaultFromJS(items, (key, value, path) => {
		if (isIndexed(value) && skipIndexedKeys.includes(key as any))
			return value.toList();

		if (isIndexed(value)) {
			return value
				.toOrderedMap()
				.mapKeys((inKey, inValue) =>
					Map.isMap(inValue) && inValue.get('id')
						? inValue.get('id')
						: inKey
				);
		}
		if (isKeyed(value)) {
			return value.toMap();
		}
		return value;
	});

export const getFromJS = (instanceId: string) => skipInstances.includes(instanceId) ? defaultFromJS : fromJS;

export const convertFilterToUrlParams = (
	urlParams: URLSearchParams,
	filters: { [key: string]: any }
) => {
	Object.entries(filters).forEach(([key, value]) => {
		if (value) {
			if (Array.isArray(value) && value.length) {
				value.forEach((item) => urlParams.append(`${key}[]`, item));
			} else if (typeof value === 'object') {
				urlParams.append(key, JSON.stringify(value));
			} else {
				urlParams.append(key, value);
			}
		}
	});
};
